import CarreraService from '@/api/CarreraService';
import PersonaService from "@/api/PersonaService";
import AuthStore from '@/store/modules/AuthStore';

export default {
  data: () => {
    return {
      impersonated: null,
      dependants: [],
      countInscriptions: {}
    };
  },

  methods: {
    loadDependants() {
      PersonaService.getDependants().then((response: any) => {
        this.dependants = response.data ?? [];
      });
    },

    switchToPerson(person: any) {
      AuthStore.impersonate(person);
      this.impersonated = person;
    },

    restoreUserPerson() {
      AuthStore.restorePerson();
      this.impersonated = null;
    },

    getCountRegistrations(idRegistro: number) {
      return CarreraService.contarMisRegistros(idRegistro, true).then(response => {
          this.countInscriptions = response;
        })
        .catch(() => {
          console.log("No se pudo contar sus registros");
        });
    },
  },
  computed: {
    userPersons() {
      return [AuthStore.originalPerson, ...this.dependants];
    }
  }
};
